import {
  ConsolidatedOffersResponse,
  OfferData,
} from '@wwe-portal/entities/offer.type';
import { CATEGORY_IDS } from '@wwe-portal/web/utils/constants/offer';

/**
 * Builds offer and category lookup maps from consolidated offer data.
 * This creates two maps for efficient O(1) lookups:
 * - offerMap: Maps offer ID to offer data
 * - categoryMap: Maps offer ID to its category ID
 *
 * @param consolidatedData - The consolidated offers response data
 * @returns Object containing offerMap and categoryMap
 */
export const buildOfferMaps = (
  consolidatedData: ConsolidatedOffersResponse['data'] | undefined
): {
  offerMap: Map<string, OfferData>;
  categoryMap: Map<string, string>;
} => {
  const offerMap = new Map<string, OfferData>();
  const categoryMap = new Map<string, string>();

  if (!consolidatedData) {
    return { offerMap, categoryMap };
  }

  const categories = [
    { id: CATEGORY_IDS.DAILY, data: consolidatedData.daily },
    { id: CATEGORY_IDS.FEATURED, data: consolidatedData.featured },
    { id: CATEGORY_IDS.CASH_PACKS, data: consolidatedData.cashPacks },
    { id: CATEGORY_IDS.REWARDS, data: consolidatedData.rewards },
    { id: CATEGORY_IDS.RUBIES, data: consolidatedData.rubies },
    { id: CATEGORY_IDS.WEBCOINS, data: consolidatedData.webCoins },
  ];

  for (const { id, data } of categories) {
    if (!data) continue;
    for (const section of data) {
      for (const offer of section.offers) {
        if (offer.OffersID) {
          offerMap.set(offer.OffersID, offer);
          categoryMap.set(offer.OffersID, id);
        }
      }
    }
  }

  return { offerMap, categoryMap };
};
